import api from "../lib/axios";

const BASE_URL = "/IdCard";

export const idCardService = {
    
  getAsync: async (cardNo) => {
    const response = await api.get(
      `${BASE_URL}/get-id-card/${cardNo}`,
    );
    return response.data;
  }
};